export enum ApiResponseStatusEnum {
    Success = "success",
    Unknown = "unknown",
    GenericError = "genericError",
    Exception = "exception",
    PriviligesError = "priviligesError",
    NotLoggedIn = "notLoggedIn",

    UnAuthorized = "unAuthorized",
    NotReady = "notReady",
    Error = "error",
}
